<template>
  <v-form v-model="valid">
    <div class="display-1">{{ $t('registration.steps[0]') }}</div>
    <v-divider class="mb-2"/>
    <player-name
      v-model="playerName"
      ref="playerName"
      class="mb-2"
    ></player-name>
    <player-address
      v-model="playerAddress"
      ref="playerAddress"
      class="mb-2"
    ></player-address>
    <player-birthday
      v-model="playerBirthday"
      ref="playerBirthday"
      class="mb-2"
    ></player-birthday>
    <player-additional
      v-model="playerAdditional"
      ref="playerAdditional"
      class="mb-2"
    ></player-additional>
      <!--emergency-contact
      v-model="emergencyContact"
    ></emergency-contact-->
  </v-form>
</template>

<script>
import playerAdditional from './subs/PlayerAdditional'
import playerAddress from './subs/PlayerAddress'
import playerBirthday from './subs/PlayerBirthday'
import playerName from './subs/PlayerName'
// import emergencyContact from './subs/EmergencyContact'

export default {
  name: 'PlayerInfo',
  components: {
    playerAdditional,
    playerAddress,
    playerBirthday,
    playerName
    // emergencyContact
  },
  data(){
    return {
      showParent2: false,
      emergencyContactIsParent: true,
      valid: true,
      playerName: {
        fname: '',
        mname: '',
        lname: '',
      },
      playerAddress: {
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      },
      playerBirthday: '',
      playerAdditional: {
        gender: '',
        citizen: 'US',
        email: '',
        phone: ''
      },
      emergencyContact: {
        emergency_contact_name: '',
        emergency_contact_relationship: '',
        emergency_contact_phone: '',
        emergency_contact_phone2: ''
      }
    }
  },
  computed: {
    event() {
      return this.$store.state.events.find(e => e.id.toString() === this.$route.params.id)
    },
    registration() {
      let r = {
        ...this.playerName,
        ...this.playerAddress,
        ...this.playerAdditional,
        bdate: this.playerBirthday,
        guardians: [ {}, {} ]
        // ...this.emergencyContact
      }
      return r
    }
  },
  methods: {
    isValid() {
      if (!this.$refs.playerName.validate()) {
        this.$vuetify.goTo(this.$refs.playerName.$el)
        return false
      }
      if (!this.$refs.playerAddress.validate()) {
        this.$vuetify.goTo(this.$refs.playerAddress.$el)
        return false
      }
      if (!this.$refs.playerBirthday.validate()) {
        this.$vuetify.goTo(this.$refs.playerBirthday.$el)
        return false
      }
      if (!this.$refs.playerAdditional.validate()) {
        this.$vuetify.goTo(this.$refs.playerAdditional.$el)
        return false
      }
      let reg = this.registration
      this.$store.commit('setCurrentRegistration', reg)
      return true
    }
  }
}
</script>

<style scoped>

</style>